class TritiumEndUserFields {
  constructor() {
    this.container = document.querySelector('.tritium-fields-container');
    if (!this.container) return;

    this.form = this.container.closest('form');
    if (!this.form) return;

    this.inputs = this.container.querySelectorAll('.tritium-input');

    // Hook into the submit phase with capture to intercept before AJAX add-to-cart
    this.form.addEventListener('submit', this.handleFormSubmit.bind(this), { capture: true });

    // Clear errors when the user types
    this.inputs.forEach(input => {
      input.addEventListener('input', () => this.clearError(input));
    });
  }

  handleFormSubmit(event) {
    let isValid = true;
    let firstInvalidInput = null;

    this.inputs.forEach(input => {
      // Basic required check
      if (input.required) {
        if (!input.value.trim()) {
          this.setError(input, 'This field is required.');
          isValid = false;
          if (!firstInvalidInput) firstInvalidInput = input;
        } else {
          // Specific validations
          if (input.type === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(input.value.trim())) {
              this.setError(input, 'Please enter a valid email address.');
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = input;
            }
          } else if (input.type === 'tel') {
            // Improved US phone validation allowing combinations like:
            // (123) 456-7890, 123-456-7890, 123 456 7890, +1 123-456-7890, 1234567890
            const phoneRegex = /^(?:\+?1[-.●]?)?\(?([0-9]{3})\)?[-.●\s]?([0-9]{3})[-.●\s]?([0-9]{4})$/;
            if (!phoneRegex.test(input.value.trim())) {
              this.setError(input, 'Please enter a valid phone number (e.g. 123-456-7890).');
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = input;
            }
          }
        }
      }
    });

    if (!isValid) {
      // Prevent normal submission and stop AJAX scripts from proceeding
      event.preventDefault();
      event.stopImmediatePropagation();
      
      // Focus first error for accessibility
      if (firstInvalidInput) {
        firstInvalidInput.focus();
      }
    }
  }

  setError(input, message) {
    input.classList.add('tritium-error');
    input.setAttribute('aria-invalid', 'true');
    const errorMsgElement = input.nextElementSibling;
    if (errorMsgElement && errorMsgElement.classList.contains('tritium-error-msg')) {
      errorMsgElement.textContent = message;
    }
  }

  clearError(input) {
    input.classList.remove('tritium-error');
    input.setAttribute('aria-invalid', 'false');
    const errorMsgElement = input.nextElementSibling;
    if (errorMsgElement && errorMsgElement.classList.contains('tritium-error-msg')) {
      errorMsgElement.textContent = '';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TritiumEndUserFields();
});
